import React, { useRef, useEffect } from 'react';

import st from './index.module.scss';

import Head from 'next/head';

import { AppearencesInMedia, BusinessInNumbers, ReviewsOn } from '../../../components/seo/sections';
import { GetPriceing, WhatHappensNext } from '../../../components/videoProduction';

const SeoForm = props => {
  const sideBar = useRef(null);
  useEffect(() => {
    document.body.classList.remove('overflow-x-hidden');
    if (sideBar.current) {
      const div = sideBar.current;

      div.style.height = div.scrollHeight + 'px';
    }
  }, []);

  return (
    <>
      <Head>
        <title>Get Pricing - Video Production Services | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/get-pricing" />
        <meta
          name="description"
          content="Request a quote for Prodigi's video production services. Get transparent pricing based on your project's specific needs."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/get-pricing" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Get Pricing - Video Production Services | Prodigi" />
        <meta
          property="og:description"
          content="Request a quote for Prodigi's video production services. Get transparent pricing based on your project's specific needs."
        />
      </Head>
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="bg-[#EEEAF9] px-[30px] md:pt-[48px] md:pb-[90px] py-[48px] ">
          <div className="flex flex-col gap-[48px] ml-auto max-w-[520px]">
            <h1 className="text-[32px] md:text-[34px] font-[600] md:leading-[48px] leading-[39px] text-black">Get Pricing</h1>
            <div className="flex flex-col gap-[24px]">
              <p className=" italic text-[16px] leading-[22px] font-normal text-[#6C6E70]">
                Kindly answer a few questions in order for us to provide you with video production pricing information. An email address is required
                in the form.*
              </p>
              <div className="w-full flex justify-end">
                <GetPriceing country={props.country} />
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white md:pl-[75px] px-[30px] py-[48px] relative z-[1]">
          <div ref={sideBar} className={`hidden md:flex flex-col absolute ${st['stickyBar']}`}>
            <div className={`flex flex-col max-w-[520px] gap-[48px] items`}>
              <h2 className="flex justify-center text-[34px] font-[600] md:leading-[72px] leading-[41px] text-[#09AF77]">What Happens Next? </h2>
              <div className="grid grid-cols-12 gap-[10px] relative pl-[30px]">
                <img className="absolute top-[9px] left-[-75px]" src="/images/video-production/here.png" alt="here" />

                <div className="col-span-11 py-[10px] px-[25px]">
                  <WhatHappensNext />
                </div>
              </div>
            </div>
          </div>

          <div className={`md:hidden flex flex-col container`}>
            <div className="flex flex-col gap-[48px] items">
              <h2 className="flex justify-center text-[34px] font-[600] md:leading-[72px] leading-[41px] text-[#09AF77]">What Happens Next? </h2>
              <div className="relative ">
                <img className="absolute top-[9px] right-[-40px]" src="/images/video-production/here_mobile.png" alt="here" />

                <div className="py-[10px]">
                  <WhatHappensNext />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ReviewsOn />
      <BusinessInNumbers color="#0052B4" />
      <AppearencesInMedia />
    </>
  );
};

export default SeoForm;
